export default class ErrorDefinitionTranslation {
    public id!: number;
    public language!: string;
    public title!: string;
    public description!: string;
    public operatorAction!: string;
    public serviceAction!: string;

    constructor(jsonData?: ErrorDefinitionTranslation) {
        if (jsonData) {
            this.id = jsonData.id;
            this.language = jsonData.language;
            this.title = jsonData.title;
            this.description = jsonData.description;
            this.operatorAction = jsonData.operatorAction;
            this.serviceAction = jsonData.serviceAction;
        }
    }
}
